module.exports = __webpack_public_path__ + "static/interior-2@2x-7ab7a734605e7551281af3c295dd63b8.jpg";